<template>
    <div class="app_page">
      <serviceQrCode :isFengChannel="channelSystem == 4" :userId="$route.query.userId" />
      <div class="policy_info">
        <p class="title_">
          投保人信息
        </p>
        <div class="item_">
          <span class="nowrap_">投保人姓名</span>
          <div>
            <input :class="checkedData.policyHolderName ? 'alert_' : ''" type="text"
                 placeholder="请输入姓名" v-model="policyFormData.holderName" @blur="changeFieldName($event,'policyHolderName')">
            <p class="empty_ red_c" v-if="checkedData.policyHolderName">姓名不能为空</p>
          </div>
        </div>
        <div class="item_">
          <span class="nowrap_">证件类型</span>
          <div>
            <div class="flex_">
            <input type="text" :class="checkedData.idTypeName ? 'alert_' : ''"
                 placeholder="请选择证件类型" readonly @click="showIdTypePicker" v-model="policyFormData.idTypeName" @blur="changeFieldName($event,'idTypeName')">
                 <img class="arrow_right" src="../../assets/image/yf/arrow-right.png" alt="icon"></div>
                 <p class="empty_" v-if="checkedData.idTypeName">请选择证件类型</p>
          </div>
        </div>
        <div class="item_">
          <span class="nowrap_">证件号码</span>
          <div>
            <input type="text" :class="checkedData.policyIdNumber ? 'alert_' : ''"
                 placeholder="请输入证件号码" v-model="policyFormData.idNumber" @blur="changeFieldName($event,'policyIdNumber')">
                 
                 <p class="empty_ red_c" v-if="checkedData.policyIdNumber">{{policyIdNumberPlaceHolder}}</p>
          </div>
        </div>
        <div class="item_">
          <span class="nowrap_">投保人数</span>
          <div>
            <input type="number" :class="checkedData.insuredNum ? 'alert_' : ''"
                 placeholder="请输入投保人数" v-model="policyFormData.insuredNum" @blur="changeFieldName($event,'insuredNum')">
                 <p class="empty_ red_c" v-if="checkedData.insuredNum">{{insuredNumPlaceHolder}}</p>
          </div>
        </div>
        <div class="item_">
          <span class="nowrap_">联系人手机号</span>
          <div>
            <input type="number" :class="checkedData.policyTelephone ? 'alert_' : ''"
                 placeholder="请输入联系人手机号" v-model="policyFormData.telephone" @blur="changeFieldName($event,'policyTelephone')">
                 <p class="empty_ red_c" v-if="checkedData.policyTelephone">{{policyIdPhonePlaceHolder}}</p>
          </div>
        </div>
      </div>
      <div class="foot_">
        <p class="circle_" v-if="!isRead" @click="radioChange"></p>
        <img style="width: 9px;height: 9px;margin-top: 3px;" src="../../assets/image/yf/right.png" alt="" v-else @click="radioChange">
        <p>
          <span>本人已认证阅读并确认</span>
          <span @click="read"
                style="color: #E77371;font-size:11px;">《保险条款》</span>
          <span>的内容，充分了解并清楚知晓购买本保险产品的风险，愿意承担相关风险</span>
        </p>
      </div>
      <div class="btn" @click="appointment">
        确认预约
      </div>
      <div class="mask_bg"
           v-if="showMaskBg">
        <div class="read_box">
          <div class="close_"
               @click="close">
            <img src="../../assets/image/yf/close.png"
                 alt="关闭">
          </div>
          <p class="read_item" @click="readMateriaContent">
            {{materialData.materialName}}
          </p>
          <div class="read_btn"
            @click="readComfirm">
            我已逐条阅读并同意
          </div>
        </div>
      </div>
      <div class="mask_bg" v-if="showContent" @click.self="showContent = false">
        <div class="agree_box">
          <div class="title">
            <span>{{materialData.materialName}}</span>
            <span class="close" @click="showContent = false"></span>
          </div>
          <div class="content">
            <div v-html="materialData.materialContent"></div>
          </div>
        </div>
      </div>
    </div>
  </template>

  
  <script>
  import api from "@/utils/nsaleApi";
  import api2 from "@/utils/api";
  import checkIdCard from "@/utils/checkIdCard"
  import sensorsEvent from '@/utils/sc.js';
  import serviceQrCode from './components/serviceQrCode.vue'
  const idTypeList = [
    { value: '1', text: '身份证'}, 
    { value: '01', text: '组织机构代码证' },
    { value: '02', text: '税务登记证' },
    { value: '03', text: '统一社会信用代码证' },
    { value: '04', text: '工商营业执照' },
  ]
  export default {
    components: {
      serviceQrCode
    },
    data() {
      return {
        idTypeList, // 证件类型
        idTypePicker: null,
        showMaskBg: false,
        policyFormData: {
          // 投保人信息
          holderName: '', //投保人姓名
          idType: '1', //证件类型 1、身份证
          idTypeName: '身份证',
          idNumber: '', //证件号码
          nationality: '中国', //国籍
          addressCode: '', //居住省市code
          addressName: '', //居住省市
          address: '', //详细地址
          postCode: '', //邮政编码
          telephone: '', //手机号
          email: '', //电子邮箱
          occupationCodeSh: '', //职业Code
          occupationNameSh: '', // 职业名称
          premiumAmt: '', // 年交保费
          // 银行卡信息
          bankName: '', // 开户银行
          receiverName: '', // 持卡人姓名
          bankCardCode: '', // 银行卡号
          reservedPhone: '', // 预留手机号
          bankCardPicture: '', // 银行卡照片url
          // 身份证
          idCardFacePicture: '', // 证件正面照url
          idCardBackPicture: '', // 证件反面照url
          // 被保人信息
          offLineInsuredReqList: [],
          // 受益人信息
          offLineBeneficiaryReqList: [],
          mdProductCode: '',
          webUserId: '',
          weight: '',// 体重
          height: '',// 身高
          annualIncome: ''// 年收入
        },
        isRead: false,
        checkedData: {
          policyHolderName: false, //投保人姓名
          policyIdNumber: false, //证件号码
          insuredNum: false, // 投保人数
          policyTelephone: false, //手机号码
        },
        materialData: {},
        showContent: false,
        productName: '',
        productCode: '',
        userId: '',
        policyIdNumberPlaceHolder: '证件号不能为空',
        insuredNumPlaceHolder: '投保人数不能为空',
        policyIdPhonePlaceHolder: '手机号码不能为空',
        channelSystem: '',
        desc: '',
        imgUrl: ''
      }
    },
    created() {
      this.materialData = JSON.parse(localStorage.getItem('materialData'))
      let { 
        productName,
        productCode,
        userId,
        channelSystem,
        desc,
        imgUrl 
      } = this.$route.query
      this.userId = userId
      this.productCode = productCode
      this.productName = productName
      this.channelSystem = channelSystem
      this.desc = desc
      this.imgUrl = imgUrl
      document.title = productName
      this.fetchJsSdkSign()
      // 埋点
      let sensorsData = sessionStorage.getItem('sensorsData') ? JSON.parse(sessionStorage.getItem('sensorsData')) : {};
      sensorsEvent(sensorsData);
    },
    methods: {
      // jssdk
      fetchJsSdkSign() {
        const url = encodeURIComponent(location.href.split('#')[0])
        // alert('获取签名url ->' + url)
        api2.getJsJdkSign2({
          url,
          userId: this.$route.query.userId
        }).then(async (data) => {
          if(!data || !data.data) {
            return
          }
          const { appId, jssdkReqData } = data.data
          if(!jssdkReqData) {
            return
          }
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
          };
          const { wxShare } = await this.$wx.wxConfig(options)
          let opstion = {
            title: this.productName, // 分享标题
            link: location.href, // 分享链接
            imgUrl: this.imgUrl, // 分享图标
            desc: this.desc, // 分享描述
          };
          wxShare(opstion)
        })
      },
      // 创建证件类型选择器
      showIdTypePicker() {
        if (!this.idTypePicker) {
          this.idTypePicker = this.$createPicker({
            title: '',
            data: [idTypeList],
            onSelect: this.selectIdTypeHandle,
          })
        }
        this.idTypePicker.show()
      },
      // 选择证件类型
      selectIdTypeHandle(selectedVal, selectedIndex, selectedText) {
        this.checkedData.idTypeName = false
        console.log(selectedVal,selectedText, 229 )
        this.policyFormData.idType = selectedVal.join(',')
        this.policyFormData.idTypeName = selectedText.join(',')
        console.log(this.policyFormData, 233)
      },
      radioChange() {
        this.isRead = !this.isRead
        if (this.isRead) {
          this.showMaskBg = true
          this.materialContent = localStorage.getItem('materialContent')
        }
      },
      readMateriaContent() {
        this.showContent = true
      },
      read() {
        this.showMaskBg = true
        this.materialContent = localStorage.getItem('materialContent')
      },
      readComfirm() {
        this.showMaskBg = false
        this.isRead = true
      },
      close() {
        this.showMaskBg = false
      },
      appointment() {
        if (!this.checkedValidData()) {
          return false
        }
        let params = {
          ...this.policyFormData,
          mdProductCode: this.productCode,
          webUserId: this.userId,
        }
        console.log(params)
        api.offlineProductInfoSendEmail(params).then(res => {
          console.log(res.data.returnCode, 267)
          if(res.data.returnCode == '0000') {
            this.$router.push({
              path: '/productAppointmentSuccess',
              query: {
                userId: this.userId,
                productName: this.productName,
                channelSystem: this.channelSystem
              }
            })
          } else {
            this.$toast(res.data.returnMsg)
          }
          
        })
      },
    
      changeFieldName(e,fieldName) {
        let value = e.target.value
        console.log(value,'验证');
        this.checkedData[fieldName] = value ? false : true
        let telReg = /^1[3456789]\d{9}$/
        if(fieldName == 'insuredNum') {
          if(this.policyFormData.insuredNum  < 1 || parseInt(this.policyFormData.insuredNum) != this.policyFormData.insuredNum) {
            this.insuredNumPlaceHolder = '请输入正整数';
            this.checkedData.insuredNum = true;
          }

        }
        if (fieldName == 'policyTelephone') {
          if  (telReg.test(this.policyFormData.telephone)) {
            this.checkedData.policyTelephone = false
          } else {
            this.policyIdPhonePlaceHolder = '请填写正确的手机号码'
            this.checkedData.policyTelephone = true
          }
        }
      },
      checkedValidData() {
        let flag = true
        if (!this.policyFormData.holderName) {
          flag = false
          this.checkedData.policyHolderName = true
        }
        if (!this.policyFormData.idNumber) {
          flag = false
          this.checkedData.policyIdNumber = true
        } else if (this.policyFormData.idType == '1' && !checkIdCard(this.policyFormData.idNumber)) {
          flag = false
          this.checkedData.policyIdNumber = true
          this.policyIdNumberPlaceHolder = '请输入正确的证件号码'
        }
        if(!this.policyFormData.insuredNum) {
          flag = false
          this.checkedData.insuredNum = true
        } else if(this.policyFormData.insuredNum < 1 || parseInt(this.policyFormData.insuredNum) != this.policyFormData.insuredNum){
          flag = false;
          this.insuredNumPlaceHolder = '请输入正整数';
          this.checkedData.insuredNum = true
        }
        if (!this.policyFormData.telephone) {
          flag = false
          this.checkedData.policyTelephone = true
        } else if(!(/^1[3456789]\d{9}$/.test(this.policyFormData.telephone))) {
          this.policyIdPhonePlaceHolder = '请填写正确的手机号码'
          flag = false
          this.checkedData.policyTelephone = true
        }
        if (!this.isRead) {
          flag = false
          this.$toast('请阅读并勾选《保险条款》')
        }
        console.log(flag, 1352)
        return flag
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .app_page {
    background: #f6f7f9;
    padding: 24px 0;
    min-height: 100vh;
    .policy_info {
      background: #fff;
      padding-top: 22px;
    }
    .title_ {
      position: relative;
      height: 19px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #292929;
      line-height: 36px;
      text-align: left;
      margin-left: 41px;
      margin-bottom: 25px;
      &::after {
        position: absolute;
        content: '';
        display: inline-block;
        width: 5px;
        height: 20px;
        background: #ff7b6f;
        border-radius: 2px;
        left: -10px;
        top: 8px;
      }
    }
    .item_ {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 65px;
      // line-height: 50px;
      color: #666;
      font-size: 15px;
      padding: 0 30px;
      border-bottom: 1px solid #f5f5f5;
      input {
        color: #666;
        font-size: 12px;
        text-align: right;
        &:focus {
          outline: none;
          border: none;
        }
        &.alert_ {
          &::-webkit-input-placeholder{
          color: #E66765;
        }
      }
      }
      .red_ {
        // width: 59px;
        padding: 0 11px;
        height: 18px;
        line-height: 18px;
        background: #fcdfe3;
        border-radius: 3px;
        color: #e66765;
        font-size: 12px;
      }
      .relate_item {
        display: inline-block;
        width: 50px;
        height: 18px;
        line-height: 18px;
        border-radius: 4px;
        font-size: 12px;
      }
      .grey_ {
        background: #ececec;
        color: #7e7e7e;
      }
      .active {
        background: #FCDFE3;
        color: #E66765;
      }
    }
    .insured_info {
      margin-top: 22px;
    }
    .benefic_info {
      margin-top: 34px;
    }
    .insurance_type_info {
      margin-top: 34px;
    }
    .id_card_info {
      margin-top: 24px;
      .id_card_upload_box {
        padding: 0 30px;
        .upload_ {
          display: flex;
          justify-content: space-between;
          .box_ {
            p {
              color: #666;
              font-size: 15px;
              margin-bottom: 6px;
            }
            .img_box {
              position: relative;
              width: 160px;
              height: 126px;
              display: flex;
              justify-content: center;
              flex-direction: column;
              margin: 0 auto;
              img.delete {
                position: absolute;
                top: 20px;
                right: 0;
                width: 20px;
                height: 20px;
                z-index: 100;
              }
            }
            img {
              width: 153px;
              height: 92px;
            }
          }
        }
        .attention_ {
          display: flex;
          margin-top: 10px;
          img {
            width: 9px;
            height: 9px;
            margin-right: 5px;
          }
          p {
            font-size: 9px;
            color: #e66765;
          }
        }
      }
    }
    .bottom_ {
      background: #fff;
      margin-top: 22px;
      padding-bottom: 17px;
    }
    .bank_card {
      margin-top: 11px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .img_box {
        position: relative;
        width: 140px;
        height: 100px;
        display: flex;
        justify-content: center;
        margin: 0 auto;
        img.delete {
          position: absolute;
          top: 0px;
          right: -2px;
          width: 20px;
          height: 20px;
          z-index: 100;
        }
        img.img_{
          margin-top: 5px;
          width: 131px;
          height: 94px;
        }
      }
      img {
        width: 131px;
        height: 94px;
      }
      p {
        color: #292929;
        font-size: 13px;
        font-weight: 600;
      }
    }
    .foot_ {
      display: flex;
      align-items: flex-start;
      color: #959494;
      font-size: 11px;
      padding: 0 30px;
      margin-top: 12px;
      margin-bottom: 20px;
      input {
        margin-top: 2px;
      }
      p {
        margin-left: 5px;
        text-align: left;
        line-height: 17px;
      }
      .circle_ {
        width: 14PX;
        height: 9PX;
        border: 1px solid #959494;
        border-radius: 50%;
        margin-top: 3px;
      }
    }
    .btn {
      font-size: 19px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 12px;
      width: 315px;
      height: 45px;
      line-height: 45px;
      background: #ff2322;
      border-radius: 15px;
      margin: 0 auto 17px;
    }
    .mask_bg {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100vh;
      background: rgba(0, 0, 0, 0.3);
      .agree_box {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 500px;
        background: #fff;
        border-radius: 20px 20px 0px 0px;
        overflow-x: hidden;
        .title {
          color: #FF0000;
          height: 55px;
          line-height: 55px;
          font-size: 18px;
          font-family: PingFang SC;
          position: sticky;
          top: 0;
          background: #fff;
          z-index: 2;
          border-bottom: 1px solid #f5f5f5;
        }
        .close {
          position: absolute;
          top: 16px;
          right: 16px;
          display: inline-block;
          width: 18px;
          height: 18px;
          background: url('../../assets/image/yf/close.png') no-repeat center/18px 18px;
        }
        .content {
          padding: 0 20px;
          box-sizing: border-box;
          /deep/ p {
            text-align: left;
            line-height: 14px;
          }
          /deep/ img {
            max-width: 100%;
            height: auto;
          }
          /deep/ strong,
          /deep/ strong span{
            font-weight: bold;
          }
        }
      }
      .read_box {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        min-height: 222px;
        background: #fff;
        border-radius: 20px 20px 0px 0px;
        padding: 22px 30px 26px;
        .close_ {
          text-align: right;
          margin-bottom: 18px;
          color: #9d9d9d;
          img {
            width: 22px;
            height: 22px;
          }
        }
        .read_item {
          font-size: 12px;
          color: #e66765;
          text-align: left;
        }
        .read_btn {
          margin-top: 93px;
          width: 315px;
          height: 45px;
          background: #ff2322;
          border-radius: 15px;
          font-size: 19px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 45px;
        }
      }
    }
    .empty_ {
      text-align: right;
      font-size: 12px;
      margin-top: 7px;
    }
    .arrow_right {
      width: 16px;
      height: 16px;
    }
    .flex_ {
      display: flex;
      align-items: center;
    }
    .nowrap_ {
      white-space: nowrap;
    }
    .red_c {
      color: #E66765;
    }
  }
  </style>
  <style lang="scss">
  .cube-picker-wheel-item {
    white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
  }
  </style>